"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var on_message_1 = require("../decorator/on-message");
exports.callOnMessage = function (topicName, value, instance) {
    var prototype = Object.getPrototypeOf(instance);
    if (!prototype[on_message_1.MESSAGE_ASSIGNMENTS])
        return;
    // walk thru @onMessage assignments
    for (var assignmentTopicName in prototype[on_message_1.MESSAGE_ASSIGNMENTS]) {
        if (assignmentTopicName !== topicName) {
            continue;
        }
        var targetMethodName = prototype[on_message_1.MESSAGE_ASSIGNMENTS][topicName];
        // call method
        instance[targetMethodName].call(instance, value);
    }
};
//# sourceMappingURL=call-on-message.js.map